import { FC, useState } from "react";
import KickImage from 'Reuseables/KickImage';
import styled from "styled-components";

//Constants
import { FontFamilyBold, FontFamilyRegular } from "../../../constants"

// Define Interface
type Props = {
  className?: string;
  check?: boolean;
  setCheck: () => void;
}

interface StyledCompProps {
  fontFamilyBold?: string;
  fontFamilyRegular?: string;
}

const StyledComponent = styled.div<StyledCompProps>`
  position: absolute;
  right: 16px;
  .button-switch {
    background: #bebebe;
    height: 24px;
    width: 40px;
    border-radius: 17px;
    display: flex;
    align-items: center;
    position: relative;
    cursor: pointer;
    .knob {
      position: absolute;
      width: 16px;
      height: 16px;
      background-color: #fff;
      border-radius: 50%;
      left: 5px;
      transition: left 0.5s ease-out;
      &.knobActive {
        left: 18px;
      }
    }
  }
  .active {
    background: #159953;
  }
`
StyledComponent.defaultProps = {
  fontFamilyBold: FontFamilyBold,
  fontFamilyRegular: FontFamilyRegular
}


const SwitchButton: FC<Props> = ({
  className,
  check,
  setCheck
}) => {
  return (
    <StyledComponent className={className} onClick={() => setCheck()}>
      <div onClick={() => setCheck()} className={`button-switch ${check ? "active" : ""}`}>
        <div className={`knob ${check ? "knobActive" : ""}`} />
      </div>
    </StyledComponent>
  )
}
SwitchButton.defaultProps = {
  className: "",
  check: false,
  setCheck: () => {}
}

export default SwitchButton;